import React from 'react';
import clsx from 'clsx';
import { ReactComponent as CloseIcon } from 'common-assets/assets/icons/close.svg';
import { ModalType } from '../../tools/ModalCore.const';
import { ModalHeaderProps } from './ModalHeader.model';

export const ModalHeader = ({
  type,
  title,
  titleType,
  handleClose,
  handleBack,
  renderBackButton,
  backButtonLabel = 'Back',
  closeButtonAriaLabel = 'Close',
  onBackButtonKeyDown,
  autoFocusRef,
  forwardedRef,
  closeButtonClassName,
  headerClassName,
  classes,
}: ModalHeaderProps): JSX.Element | null => {
  const clsxTitleClassName = clsx(
    classes.title,
    (titleType === 'center' && classes['title--center']),
    (titleType === 'left' && classes['title--left'])
  );

  switch (type) {
    case ModalType.withBackBtn:
    case ModalType.withBackBtnAndTitle:
      if (renderBackButton) {
        return <>{renderBackButton()}</>;
      }
      return (
        <button
          ref={autoFocusRef}
          onClick={handleClose}
          className={classes.goBackButton}
          data-testid="modal-back-button"
          aria-label={backButtonLabel}
          onKeyDown={onBackButtonKeyDown}
        >
          {backButtonLabel}
        </button>
      );

    case ModalType.withHeader:
      return (
        <header className={clsx(classes.header, headerClassName)}>
          <span className={clsxTitleClassName}>{title}</span>
          <button
            ref={autoFocusRef}
            onClick={handleClose}
            className={clsx(classes.closeButton, closeButtonClassName)}
            onKeyDown={onBackButtonKeyDown}
            aria-label={closeButtonAriaLabel}
          >
            <CloseIcon />
          </button>
        </header>
      );

    case ModalType.withBackAndCloseBtn:
      return (
        <header className={classes.headerWithButtons}>
          <div className={classes.buttonsWrapper}>
            {renderBackButton ? (
              <>{renderBackButton()}</>
            ) : (
              <button
                ref={forwardedRef}
                onClick={handleBack}
                className={classes.goBackButton}
                data-testid="modal-back-button"
                aria-label={backButtonLabel}
              >
                {backButtonLabel}
              </button>
            )}
            <button
              ref={autoFocusRef}
              onClick={handleClose}
              className={clsx(classes.closeButton, closeButtonClassName)}
              onKeyDown={onBackButtonKeyDown}
              aria-label={closeButtonAriaLabel}
            >
              <CloseIcon aria-hidden="true" focusable="false" />
            </button>
          </div>
          <span className={classes.titleWithButtons}>{title}</span>
        </header>
      );

    case ModalType.menuModal:
      return (
        <header className={classes.menuModal}>
          <button
            ref={autoFocusRef}
            onClick={handleClose}
            className={clsx(classes.closeButton, closeButtonClassName)}
            onKeyDown={onBackButtonKeyDown}
            aria-label={closeButtonAriaLabel}
          >
            <CloseIcon aria-hidden="true" focusable="false" />
          </button>
          <span className={classes.titleWithButtons}>{title}</span>
        </header>
      );

    case ModalType.modalCard:
    default:
      return null;
  }
};

